/**
 * Logo SmartPOS — usa el mismo asset en todas las páginas (marca de agua de videos).
 * El variant se mantiene por compatibilidad pero ahora usa un único logo.
 */
const LOGO_SMARTPOS = "https://media.base44.com/images/public/6a877e598e2aae01ac439787/966e8fe32_Logo6.png/v1/fit/w_200,h_64,q_90,usm_0.66_1.00_0.01,enc_webp,quality_auto/Logo6.webp";

export default function Logo({ variant = "color", className = "", imgClassName = "", invert = false, loading = "eager" }) {
  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={LOGO_SMARTPOS}
        alt="SmartPOS"
        className={`w-auto select-none ${imgClassName || 'h-[2.925rem]'}`}
        style={{ objectFit: 'contain', filter: invert ? 'invert(1) hue-rotate(180deg)' : undefined }}
        draggable={false}
        loading={loading}
        decoding="async"
      />
    </div>
  );
}